import '@/utils/polyfill';

import { createApp, watch } from 'vue';
import { version } from '../package.json';

import Orion, { logBusEvents, setThemeMode } from '@orion.ui/orion';
import '@orion.ui/orion/dist/monkey-patching';

import './i18n/global'; // Initialize global $t helper
import I18nFlatKeyPlugin from './i18n/vue-plugin';

// Import App after Orion to correctly override Orion's styles
import App from '@/App.vue';
import router from '@/router/index.router';
import { initElasticApm, initMixpanel, initSentry, setArmadoApp } from './app';
import { sharedComponents } from './components/shared';
import { getSavedLocale, i18n, setLocale } from './i18n';
import useBusService from './services/BusService';
import useRouterHistoryService from './services/RouterHistoryService';
import { isDevelopmentEnv } from './utils/CONST';

(async () => {

	if (!/MSIE|Trident/.test(navigator.userAgent)) { // Filter Internet Explorer

		// Browser CSS class for specific rules
		if (navigator.userAgent.includes('Firefox')) {
			document.body.classList.add('firefox');
		}

		// await useFeatureFlagService().getAsync('userfingerprint');
		// await useFeatureFlagService().getAsync('onboarding');

		watch(router.currentRoute, (to) => {
			useRouterHistoryService().addRouterHistory(to);
		});

		// Initialiser la langue sauvegardée AVANT le mount
		setLocale(getSavedLocale());

		const app = createApp(App);

		setArmadoApp(app);
		initSentry(app, router);
		initElasticApm(app, router);
		initMixpanel();

		app
			.use(router)
			.use(i18n)
			.use(I18nFlatKeyPlugin)
			.use(Orion, {
				lang: ['fr', 'en'].includes(getSavedLocale()) ? getSavedLocale() : 'en',
				router,
			} as Orion.Config)
			.provide('appVersion', version)
			.use(sharedComponents)
			.mount('#app');

		setThemeMode('light');

		if (isDevelopmentEnv) {
			logBusEvents();
			useBusService().logBusEvents();
		}
	}

})();
